import { render, staticRenderFns } from "./ItemQuote.vue?vue&type=template&id=c2c23438&scoped=true&"
import script from "./ItemQuote.vue?vue&type=script&lang=js&"
export * from "./ItemQuote.vue?vue&type=script&lang=js&"
import style0 from "./ItemQuote.vue?vue&type=style&index=0&id=c2c23438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c23438",
  null
  
)

export default component.exports